import CartPlaceOrderReducer from "@tSurya/Store/Reducer/CartPlaceOrderReducer";
import ConfiguratorReducer from "@tSurya/Store/Reducer/ConfiguratorReducer";
import CreditDataReducer from "@tSurya/Store/Reducer/CreditDataReducer";
import DownloadTearSheetReducer from "@tSurya/Store/Reducer/DownloadTearSheetReducer";
import FilterDrawerReducer from "@tSurya/Store/Reducer/FilterDrawerReducer";
import OrderStatusReducer from "@tSurya/Store/Reducer/OrderStatusReducer";
import SurDesignerProductsReducer from "@tSurya/Store/Reducer/SurDesignerProductsReducer";
import SurFinancialTransactionReducer from "@tSurya/Store/Reducer/SurFinancialTransactionReducer";
import SurGetCustomerDetailsReducer from "@tSurya/Store/Reducer/SurGetCustomerDetailsReducer";
import SurGetCustomPropertiesReducer from "@tSurya/Store/Reducer/SurGetCustomPropertiesReducer";
import SurHeaderHeightReducer from "@tSurya/Store/Reducer/SurHeaderHeightReducer";
import IsCheckoutReviewReducer from "@tSurya/Store/Reducer/SurIsCheckoutReviewSubmitPage";
import loadMoreDesignerProductsReducer from "@tSurya/Store/Reducer/SurLoadMoreDesignerProductsReducer";
import loadMoreReducer from "@tSurya/Store/Reducer/SurLoadMorePLPReducer";
import SurOpenTradeAccountReducer from "@tSurya/Store/Reducer/SurOpenTradeAccountReducer";
import SurOpenTradeBillingInfoCheckboxReducer from "@tSurya/Store/Reducer/SurOpenTradeBillingInfoCheckboxReducer";
import SurOrderHistoryReducer from "@tSurya/Store/Reducer/SurOrderHistoryReducer";
import SurProductDataPoint from "@tSurya/Store/Reducer/SurProductDataPointReducer";
import toggleFilterReducer from "@tSurya/Store/Reducer/SurProductListHideAndShowFilterReducer";
import SurUnApprovedCustomersReducer from "@tSurya/Store/Reducer/SurUnApprovedCustomersReducer";
import SwatchCartReducer from "@tSurya/Store/Reducer/SwatchCartReducer";
import ProjectLineAddToCartReducer from "@tSurya/Store/Reducer/ProjectLineAddToCartReducer";
import ShippingAddressOptionSelectedReducer from "@tSurya/Store/Reducer/SurShippingAddressOptionSelected";
import ViewReturnReducer from "@tSurya/Store/Reducer/ViewReturnReducer";
import ViewReturnsDetailsReducer from "@tSurya/Store/Reducer/ViewReturnsDetailsReducer";
import { combineReducers } from "redux";

const customDataReducerData = {
    toggleFilter: toggleFilterReducer,
    creditDataStore: CreditDataReducer,
    viewDataStore: ViewReturnReducer,
    surFilterDataStore: SurOrderHistoryReducer,
    financialTransactionStore: SurFinancialTransactionReducer,
    openTradeAccountStore: SurOpenTradeAccountReducer,
    viewReturnsDetailsStore: ViewReturnsDetailsReducer,
    customPropertiesData: SurGetCustomPropertiesReducer,
    loadMore: loadMoreReducer,
    loadMoreDesignerProducts: loadMoreDesignerProductsReducer,
    headerHeightStore: SurHeaderHeightReducer,
    isReviewSubmitPage: IsCheckoutReviewReducer,
    unApprovedCustomersData: SurUnApprovedCustomersReducer,
    unApprovedCustomerDeatilsData: SurGetCustomerDetailsReducer,
    productDataPointContent: SurProductDataPoint,
    checkBoxCustomStore: SurOpenTradeBillingInfoCheckboxReducer,
    orderStatusDetails: OrderStatusReducer,
    attributeValueDetails: CartPlaceOrderReducer,
    designerProductsStore: SurDesignerProductsReducer,
    filterDrawerReducer: FilterDrawerReducer,
    downloadTearSheetReducer: DownloadTearSheetReducer,
    configuratorStore: ConfiguratorReducer,
    swatchCart: SwatchCartReducer,
    projectLineAddToCart: ProjectLineAddToCartReducer,
    shippingAddressOptionSelected: ShippingAddressOptionSelectedReducer,
};

export type DataReducers = typeof customDataReducerData;

const customDataReducer = combineReducers(customDataReducerData as any);

export default customDataReducer;
